export const paths = {
  root: '/',
  home: '/home',
  disk: '/net-disk',
  department: '/department',
  role: '/role',
  user: '/user',
  folder: '/folder',
  log: '/operation-log',
  dashboard: '/dashboard',
  downloadView: '/download-view',
  share: '/share',
  departmentRole: '/department-role',
  userAgreement: '/user-agreement',

  forbidden: '/403',
  notFound: '/404',
  redirect4login: '/login-redirect',
  roleAdd: 'role/add',
  roleEdit: 'role/edit',
}
